import styled from 'styled-components';

import { IconCloudSync } from '@components/icons/cloud-sync';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { pxToRem } from '@utils/converters';

import { OptionLabel } from './styles';

type ListOptionLabelProps = {
  name: string;
  isSynced: boolean;
  isSyncActive?: boolean;
  tooltip?: string;
};

export const ListOptionLabel = ({
  name,
  isSynced,
  isSyncActive,
  tooltip,
}: ListOptionLabelProps) => {
  if (!isSynced) return <>{name}</>;

  return (
    <Stack orientation="horizontal" align="center" justify="space-between">
      <ListName font="regular14" text={name} ellipsis />
      <IconCloudSync
        size={16}
        color={isSyncActive ? 'green100' : 'buttonIconPositive'}
        style={{ marginLeft: pxToRem(8) }}
        tooltip={tooltip}
      />
    </Stack>
  );
};

const ListName = styled(Text)({
  [`${OptionLabel} &`]: {
    whiteSpace: 'pre-wrap',
  },
});
